import { enqueueSnackbar } from 'notistack';
import { defaultTo, equals, isNil } from 'ramda';

import { setValue } from '@gef-ui/form-core/stream/transfer/control';
import { getMessage } from '@gef-ui/localization/messages';

import { EMPTY_VALUES } from 'constants/general';
import fetch from 'features/common/fetch';
import { getUser } from 'features/views/user/selectors';
import { getContextUser } from 'features/views/userContext/selectors';

import { revertFeedback, updateSemaphoreRecord } from '../actions';
import { getFeedbackByRecordId } from '../selectors';
import { FIELDS, SEMAPHORE_FEEDBACK_DETAIL_FORM_NAME } from './form';

export const submitChanges =
	(record) =>
	async (dispatch, getState, { getFormData }) => {
		const { note, feedback, partnerId } = record;

		const userLogin = getUser(getState());
		const contextUser = getContextUser(getState());

		const formData = await getFormData(SEMAPHORE_FEEDBACK_DETAIL_FORM_NAME);
		const possiblyChangedFormNote = !isNil(formData?.feedbackNote) ? formData.feedbackNote.trim() : undefined;

		const originalNote = note.text;

		// if no feedback yet, default to empty string so it matches with initialized empty feedback value
		const originalFeedback = defaultTo(EMPTY_VALUES.STRING)(feedback.feedbackId);
		const possiblyChangedFeedback = getFeedbackByRecordId(getState(), record.partnerId);

		const isNoteChanged = !equals(originalNote, possiblyChangedFormNote);
		const isFeedbackChanged = !equals(originalFeedback, possiblyChangedFeedback);

		if (isNoteChanged) {
			const body = {
				note: possiblyChangedFormNote,
				partnerId,
				userName: contextUser ? contextUser.login : userLogin,
			};

			dispatch(
				fetch.actions.put(fetch.constants.urls.semaphoreSaveFeedbackNote, {
					body,
					onSuccess: [
						() => () => {
							dispatch(
								updateSemaphoreRecord(['note', 'text'], possiblyChangedFormNote, record.partnerId),
							);
							enqueueSnackbar(getMessage('toastr:semaphoreFeedbackDetailUpdated'), {
								variant: 'success',
							});
						},
					],
				}),
			);
		}

		if (isFeedbackChanged) {
			const body = {
				feedbackValueId: possiblyChangedFeedback,
				partnerId,
				userName: contextUser ? contextUser.login : userLogin,
			};

			dispatch(
				fetch.actions.put(fetch.constants.urls.semaphoreSaveFeedbackValue, {
					body,
					onSuccess: [
						() => () => {
							dispatch(
								updateSemaphoreRecord(
									['feedback', 'feedbackId'],
									possiblyChangedFeedback,
									record.partnerId,
								),
							);
							enqueueSnackbar(getMessage('toastr:semaphoreFeedbackDetailUpdated'), {
								variant: 'success',
							});
						},
					],
				}),
			);
		}
	};

export const revertChanges =
	(record) =>
	(dispatch, getState, { sendControlNext }) => {
		const { note, partnerId, feedback } = record;
		sendControlNext(
			SEMAPHORE_FEEDBACK_DETAIL_FORM_NAME,
			setValue({ fieldName: FIELDS.feedbackNote, value: note.text }),
		);
		dispatch(revertFeedback(partnerId, feedback.feedbackId));
	};
